import React from "react";
import HStack from "@components/layout/HStack";
import { useThemeStore } from "@shared/stores";
import { ChevronRight } from "../icons/IconCustom";

type Props = {
  header: React.ReactNode;
  children: React.ReactNode;
  isOpen?: boolean;
  onToggleOpen?: () => void;
  className?: string;
  isUseAccordionIcon?: boolean;
};

const Accordion = ({
  header,
  children,
  isOpen = false,
  onToggleOpen = () => {},
  className = "",
  isUseAccordionIcon = true,
}: Props) => {
  const { isDarkMode } = useThemeStore();

  return (
    <div className={`w-full ${className}`}>
      {/* Header */}
      <HStack
        justifyContent="between"
        className={`w-full cursor-pointer transition-all duration-300
          `}
        onClick={onToggleOpen}
      >
        {header}
        {isUseAccordionIcon ? (
          <ChevronRight
            isDarkMode={isDarkMode}
            className={`transition-transform duration-200 ${isOpen ? "rotate-90" : "rotate-0"}`}
          />
        ) : null}
      </HStack>

      {/* Content */}
      <div className={`w-full overflow-hidden transition-all duration-300 ${isOpen ? "max-h-[2000px]" : "max-h-0"}`}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;
